// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__T84kS","header":"Layout_header__zwfg9"};